// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h1-3";
export var downloadButton = "_h1-4";
export var fileContainer = "_h1-9 _h1-7";
export var fileContainerBase = "_h1-7";
export var fileContainerBaseSm = "_h1-a _h1-7";
export var fileContainerFixedHeight = "_h1-8 _h1-7";
export var fileContainerFixedHeightSm = "_h1-c _h1-a _h1-7";
export var fileContainerSm = "_h1-b _h1-a _h1-7";
export var fileInfo = "_h1-5";
export var fileInfoWidthRestricted = "_h1-6";
export var fileType = "_h1-1";
export var fileTypeName = "_h1-2";
export var fileTypeSm = "_h1-d _h1-1";
export var image = "_h1-0";
export var link = "_h1-f";
export var overflowEllipsis = "_h1-e";